import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Redux
import { connect } from 'react-redux';

// Redux Form
import { Field, reduxForm, formValueSelector, change } from 'redux-form';

import {
  Button,
  Form,
  Grid,
  Row,
  FormGroup,
  Col,
  ControlLabel,
  FormControl,
  FieldGroup,
  Panel,
  Label,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Payment.css';

// Helpers
import validate from './validate';
import submit from './submit';

// Component
import ListingRules from './ListingRules';
import Loader from '../../Loader';
// Locale
import messages from '../../../locale/messages';
import ManageCards from './ManageCards';
import ApplyPromoCode from './../../../components_new/Payment/ApplyPromoCode';

class PaymentForm extends Component {
  static propTypes = {
    listingRules: PropTypes.arrayOf(
      PropTypes.shape({
        description: PropTypes.string.isRequired,
      }),
    ),
    hostDisplayName: PropTypes.string.isRequired,
    allowedPersonCapacity: PropTypes.number.isRequired,
    initialValues: PropTypes.shape({
      listId: PropTypes.number.isRequired,
      listTitle: PropTypes.string.isRequired,
      hostId: PropTypes.string.isRequired,
      guestId: PropTypes.string.isRequired,
      checkIn: PropTypes.object.isRequired,
      checkOut: PropTypes.object.isRequired,
      guests: PropTypes.number.isRequired,
      basePrice: PropTypes.number.isRequired,
      cleaningPrice: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      weeklyDiscount: PropTypes.number,
      monthlyDiscount: PropTypes.number,
      paymentType: PropTypes.number,
    }).isRequired,
    paymentCurrencyList: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        symbol: PropTypes.string.isRequired,
        isEnable: PropTypes.bool.isRequired,
        isPayment: PropTypes.bool.isRequired,
      }),
    ),
    paymentLoading: PropTypes.bool,
    formatMessage: PropTypes.func,
  };

  static defaultProps = {
    paymentCurrencyList: [],
    paymentLoading: false,
  };

  constructor(props) {
    super(props);
    this.renderpaymentCurrencies = this.renderpaymentCurrencies.bind(this);
  }

  renderFormControlTextArea = ({ input, label, meta: { touched, error }, children, className }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup>
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
        <FormControl {...input} className="textarea h-50" placeholder={label}>
          {children}
        </FormControl>
      </FormGroup>
    );
  };

  renderFormControl = ({ input, label, type, meta: { touched, error }, className, placeholder }) => {
    return (
      <FormGroup>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <label className="normal">{label}</label>
          </Col>
        </Row>
        <Row>
          <Col xs={12} sm={9} md={9} lg={9}>
            {touched && error && <span className={s.errorMessage}>{error}</span>}
            <FormControl {...input} placeholder={placeholder} type={type} className={className} />
          </Col>
        </Row>
      </FormGroup>
    );
  };

  renderGuests(personCapacity) {
    let rows = [];
    for (let i = 1; i <= personCapacity; i++) {
      rows.push(
        <option key={i} value={i}>
          {i} {i > 1 ? 'guests' : 'guest'}
        </option>,
      );
    }
    return rows;
  }

  renderpaymentCurrencies() {
    const { paymentCurrencyList } = this.props;
    let rows = [];

    if (paymentCurrencyList != null && paymentCurrencyList.length > 0) {
      paymentCurrencyList.map((item, index) => {
        if (item.isEnable && item.isPayment) {
          rows.push(
            <option key={index} value={item.symbol}>
              {item.symbol}
            </option>,
          );
        }
      });
    }
    return rows;
  }

  onPromoSuccess = promoCode => {
    this.props.change('promoCode', promoCode);
  };

  select = cardId => {
    this.props.change('cardId', cardId);
  };

  render() {
    const { hostDisplayName, listingRules, allowedPersonCapacity, paymentLoading } = this.props;
    const { handleSubmit, submitting, error, pristine, paymentType } = this.props;
    const { formatMessage } = this.props.intl;
    // console.log("paymentType", paymentType);
    return (
      <div className={cx(s.bookItPanel, s.spaceTop2)}>
        <form onSubmit={handleSubmit(submit)}>
          <Row>
            <Col md={10} className={cx(s.textLeft)}>
              <Row>
                <h3 className={s.pullLeft}>
                  1. <FormattedMessage {...messages.aboutYourTrip} />
                </h3>
              </Row>
              <div className={cx(s.bookItDetails, s.spaceTop2, s.space4, s.textLeft)}>
                <span>
                  <FormattedMessage {...messages.sayHello} />:
                </span>
              </div>
              <div>
                <Field
                  className="h-50 mt-m"
                  name="message"
                  component={this.renderFormControlTextArea}
                  label={formatMessage(messages.descriptionInfo)}
                />
              </div>
              {listingRules.length > 0 && (
                <div>
                  <ListingRules hostDisplayName={hostDisplayName} listingRules={listingRules} />
                </div>
              )}
            </Col>

            <Col md={10} className={cx(s.textLeft)}>
              <section>
                <header className={s.paymentHeader}>
                  <Row>
                    <Col md={10} className={cx(s.textLeft)}>
                      <h3 className={s.pullLeft}>
                        2.
                        <FormattedMessage {...messages.payment} />
                      </h3>
                    </Col>
                  </Row>
                </header>
              </section>
              <Row className={s.space4}>
                <Col xs={12}>
                  <span className="gray-dark-medium">
                    Your credit card information will hold the item for you. You will only be charged if your request is
                    accepted by the owner. They’ll have up to 48 hours to accept or decline, but most hosts respond
                    quickly.
                  </span>
                </Col>
              </Row>
              <Row className={s.space4}>
                <Col xs={12} sm={12} md={12} lg={12} className={s.countryName}>
                  <span className={s.textRegular}>
                    <FormattedMessage {...messages.creditCard} />
                  </span>
                </Col>
                <Col xs={12} sm={12} md={10} lg={10}>
                  <ManageCards select={this.select} />
                </Col>
              </Row>
              <Row className={s.space4}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <ApplyPromoCode onSuccess={this.onPromoSuccess} />
                </Col>
              </Row>
              <Row className={s.space4}>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <Loader
                    type={'button'}
                    buttonType={'submit'}
                    className={cx(s.button, s.btnPrimary, s.btnlarge)}
                    disabled={pristine || submitting || error}
                    show={paymentLoading}
                    label={'Send reservation request'}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </form>
      </div>
    );
  }
}

PaymentForm = reduxForm({
  form: 'PaymentForm', // a unique name for this form
  validate,
})(PaymentForm);

// Decorate with connect to read form values
const selector = formValueSelector('PaymentForm'); // <-- same as form name

const mapState = state => ({
  paymentCurrencyList: state.currency.availableCurrencies,
  paymentLoading: state.book.paymentLoading,
  paymentType: selector(state, 'paymentType'),
});

const mapDispatch = {
  change,
};

export default injectIntl(withStyles(s)(connect(mapState, mapDispatch)(PaymentForm)));



// WEBPACK FOOTER //
// ./src/components/Booking/Payment/PaymentForm.js